<template>
    <div class="data_area">
        <div class="data_population ps-02">
            <div class="top_right_txt" style="color: rgb(251, 242, 103); position: relative;" v-if="$_WC.isMobile">※ 방문 전 해당 의료기관의 실제 운영여부를 꼭 확인하시기 바랍니다.</div>
            <!-- <h4>{{ selectedHpCate == 'LFCNVNC_01'? '병의원' : '약국' }} 현황</h4> -->
            <h4 v-if="facList.length > 0"><span class="ct_01">{{ facCateNm }}</span> {{ selectedHpCate == 'LFCNVNC_01'? '병의원' : '약국' }} 현황 - {{ facList.length }}개</h4>
            <!-- <span class="txt_r ft10" v-if="facList.length > 0">({{ facCateNm }} - {{ facList.length }}개)</span> -->
            <!-- <span class="txt_r ft10" v-else></span> -->

            
            <div class="lifemap_list scroll10" v-if="facList.length > 0">
                <ul class="list" v-if="selectedHpCate == 'LFCNVNC_01'">
                    <li v-for="(fac, idx) in facList" :key="fac.val2 + idx" @click.prevent="facDetail(fac)" style="cursor:pointer;">
                        <div class="tit">
                            <!-- <span class="ct_01">{{ facCateNm }}</span>  -->
                            {{ idx + 1 }}. {{ fac.val2 }} ({{ setManageTm(fac) }})
                        </div>
                    </li>
                </ul>
                <ul class="list" v-if="selectedHpCate == 'LFCNVNC_02'">
                    <li v-for="(fac, idx) in facList" :key="fac.val1 + idx" @click.prevent="facDetail(fac)" style="cursor:pointer;">
                        <div class="tit">
                            <!-- <span class="ct_01">{{ facCateNm }}</span>  -->
                            {{ idx + 1 }}. {{ fac.val1 }} ({{ setPharManageTm(fac) }})
                        </div>
                    </li>
                </ul>
            </div>
            <div class="lifemap_list scroll10" v-else>
                <ul class="list">
                    <li>
                        <div class="tit">
                            검색 결과가 없습니다.
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { $_WC } from '@/confs/common.const.js';

export default {
    data() {
        return {
            facList: [],
            facCateNm: '',
            searchVal: '',
        }
    },
    watch: {
        selectedLfcnvncItems: {
            immediate: false,
            handler(newVal, oldVal) {
                newVal.forEach(mn => {
                    if(mn.checked) {
                        this.setFacList(mn);
                    }
                });
            }
        },
        searchVal: {
            immediate: false,
            handler(newVal, oldVal) {
                if(!!this.selectedLfcnvncItems) {
                    this.selectedLfcnvncItems.forEach(mn => {
                        if(mn.checked) {
                            this.setFacList(mn);
                        }
                    });
                }
            }
        },
        selectedHpCate: {
            immediate: false,
            handler(newVal, oldVal) {
                this.searchVal = '';
                this.$eventBus.$emit('Set::Empty');
            }
        },
    },
    components: {
    },
    computed: {
        ...mapGetters({
            selectedLfcnvncItems: 'getSelectedLfcnvncItems',
            selectedHpCate: 'getSelectedHpCate',
        }),
    },
    created() {
    },
    mounted() {
        this.$eventBus.$on('Set::Search::Value::HosPhar', searchVal => {
            this.searchVal = searchVal;
        });
        this.$eventBus.$on('Set::Empty', () => {
            this.searchVal = '';
        });
    },
    methods: {
        setFacList(menu) {
            let listNm = menu.dataKdSqno + 'List';
            this.facCateNm = menu.name;
            listNm = listNm.charAt(0).toUpperCase() + listNm.substring(1, listNm.length);
            let list = this.$store.getters['get'+listNm];
            list.forEach(d => {
                d.cateNm = menu.name;
            });
            if(!!this.searchVal) {
                if(this.selectedHpCate == 'LFCNVNC_01') {
                    list = list.filter(d => {
                        return d.val2.includes(this.searchVal) || !!d.val32 && d.val32.includes(this.searchVal);
                    });
                }
                if(this.selectedHpCate == 'LFCNVNC_02') {
                    list = list.filter(d => {
                        return d.val1.includes(this.searchVal);
                    });
                }
            }
            this.facList = list;
        },
        setManageTm(fac) {
            let fromNm = '';
            let toNm = '';

            let date = new Date();
            let day = date.getDay();
            let returnVal = '';
            let dayNm = '';
            switch (day) {
                case 1:
                    fromNm = 'val14'; toNm = 'val15';dayNm = '월';
                    break;
                case 2:
                    fromNm = 'val16'; toNm = 'val17';dayNm = '화';
                    break;
                case 3:
                    fromNm = 'val18'; toNm = 'val19';dayNm = '수';
                    break;
                case 4:
                    fromNm = 'val20'; toNm = 'val21';dayNm = '목';
                    break;
                case 5:
                    fromNm = 'val22'; toNm = 'val23';dayNm = '금';
                    break;
                case 6:
                    fromNm = 'val24'; toNm = 'val25';dayNm = '토';
                    break;
                case 7:
                    fromNm = 'val26'; toNm = 'val27';dayNm = '일';
                    break;
                default:
                    fromNm = ''; toNm = '';
                    break;
            }
            if(!!fac[fromNm] && !!fac[toNm]) {
                returnVal = fac[fromNm].substring(0,2) + ':' + fac[fromNm].substring(2,4) + '~' + fac[toNm].substring(0,2) + ':' + fac[toNm].substring(2,4);
            } else {
                returnVal = '휴무';
            }
            returnVal = dayNm + ' - ' + returnVal;
            return returnVal;
            // 반환값 1: 월요일, 반환값 6: 토요일, 반환값 0: 일요일
        },
        facDetail(fac) {
        	if(typeof fac !== 'undefined') {
        	    if(fac.lgtdVal && fac.lttdVal) {
                    var vm = this;
                    var marker = fac.marker;
                    var w = window.innerWidth;
                    var DIDwidth = (1920 * 3);
                    marker.eventY = marker.y;
                    marker.eventX = marker.x;

                    this.$store.dispatch("SET_SELECTED_MARKER", marker);
                    this.$eventBus.$emit('setFacilityInfo', fac);
                    // vm.$parent.$refs.facilityInfoWin.setFacilityInfo(fac);
                }
        	}
        },
        setPharManageTm(fac) {
            let fromNm = '';
            let toNm = '';

            let date = new Date();
            let day = date.getDay();
            let returnVal = '';
            let dayNm = '';
            switch (day) {
                case 1:
                    fromNm = 'val5'; toNm = 'val6';dayNm = '월';
                    break;
                case 2:
                    fromNm = 'val7'; toNm = 'val8';dayNm = '화';
                    break;
                case 3:
                    fromNm = 'val9'; toNm = 'val10';dayNm = '수';
                    break;
                case 4:
                    fromNm = 'val11'; toNm = 'val12';dayNm = '목';
                    break;
                case 5:
                    fromNm = 'val13'; toNm = 'val14';dayNm = '금';
                    break;
                case 6:
                    fromNm = 'val15'; toNm = 'val16';dayNm = '토';
                    break;
                case 7:
                    fromNm = 'val17'; toNm = 'val18';dayNm = '일';
                    break;
                default:
                    fromNm = ''; toNm = '';
                    break;
            }
            if(!!fac[fromNm] && !!fac[toNm]) {
                returnVal = fac[fromNm].substring(0,2) + ':' + fac[fromNm].substring(2,4) + '~' + fac[toNm].substring(0,2) + ':' + fac[toNm].substring(2,4);
            } else {
                returnVal = '휴무';
            }
            returnVal = dayNm + ' - ' + returnVal;
            return returnVal;
            // 반환값 1: 월요일, 반환값 6: 토요일, 반환값 0: 일요일
        },
    },
};
</script>
<style>
.scroll::-webkit-scrollbar {width:12px;} /* Let's get this party started */

.lifeconv_info h4 .ct_01{
    background: transparent;
    border-radius: 30px;
    border: solid 3px #ff902d;
    color: #ff902d;
    padding: 5px;
}

.lifeconv_info .lifemap_list .tit{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
@media (min-width: 2737px) and (max-width: 7680px) {
    .scroll::-webkit-scrollbar {width:12px;} /* Let's get this party started */

    .lifeconv_info h4 .ct_01{
        border-radius: 60px;
        border-width: 5px;
        padding: 15px;
    }
}
@media (min-width: 0) and (max-width: 768px) {
    .lifeconv_info .data_population h4{
        margin-top: 5px;
    }
}
</style>